import { render, staticRenderFns } from "./member-name.vue?vue&type=template&id=fd1c18a0&"
import script from "./member-name.ts?vue&type=script&lang=js&"
export * from "./member-name.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports